import gestion from './gestion'

export default [...gestion]
